import { bpPostJson } from './burialPointAxios';

// 埋点
export const uploadPointData = (p) => bpPostJson(`/yeion-operate-data/collection/uploadPointData`, p);